import { memo } from 'react';
import dayjs from 'dayjs';

import { HeaderType } from '@utils/types';
import { autoHyphen } from '@utils/common';
import { Qr } from '@graphql/types';

import { TableRow, TableCell } from '@components/share/Table/table.style';
import theme from '@styles/theme';

type QrStatusTableRowType = {
    header: HeaderType[];
    data: Qr;
    onDelete: (id: number) => void;
};

const QrStatusTableRow = ({
    header = [],
    data,
    onDelete
}: QrStatusTableRowType) => {
    return (
        <TableRow $default>
            <TableCell $minWidth={header[0].minWidth} $width={header[0].width}>
                {data?.createSequenct || '-'}
            </TableCell>
            <TableCell $minWidth={header[1].minWidth} $width={header[1].width}>
                {data?.qrNum || '-'}
            </TableCell>
            <TableCell $minWidth={header[2].minWidth} $width={header[2].width}>
                {data?.regDate ? dayjs(data.regDate).format('YYYY-MM-DD') : '-'}
            </TableCell>
            <TableCell $minWidth={header[3].minWidth} $width={header[3].width}>
                {data?.ownerName || '-'}
            </TableCell>
            <TableCell $minWidth={header[4].minWidth} $width={header[4].width}>
                {data?.ownerCellphone ? autoHyphen(data?.ownerCellphone) : '-'}
            </TableCell>
            <TableCell $minWidth={header[5].minWidth} $width={header[5].width}>
                {data?.ownerEmail || '-'}
            </TableCell>
            <TableCell $minWidth={header[6].minWidth} $width={header[6].width}>
                {data?.petRegNum || '-'}
            </TableCell>
            <TableCell
                $minWidth={header[7].minWidth}
                $width={header[7].width}
                onClick={() => onDelete(data?.qrId as number)}
                $cursor
                $fontColor={theme.colors.deepGrayFontColor}
            >
                삭제
            </TableCell>
        </TableRow>
    );
};

export default memo(QrStatusTableRow);
